// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"289":"d27ae859","787":"488e08d1"}[chunkId] + ".chunk.js";
};